import React from 'react'
import { useTranslation } from '@mc/i18n'
import { CHECKOUT_I18N_NAMESPACE } from '../../../../i18n'
import { STEPS } from '../../../../lib'
import { useNavigationSteps } from '../../useNavigationSteps'
import { Step } from '../Step'

export const CheckoutSteps = ({
  className = '',
  stepClassName = '',
}: {
  className?: string
  stepClassName?: string
}) => {
  const { t } = useTranslation(CHECKOUT_I18N_NAMESPACE)
  const {
    context: { hideNavbarElements, isGift },
  } = useNavigationSteps()

  if (hideNavbarElements) {
    return null
  }

  return (
    <div
      role='group'
      aria-label={t('nav.steps.a11y.ariaLabel')}
      className={className}
    >
      <Step
        name={isGift ? t('nav.steps.gift') : t('nav.steps.membership')}
        stepId={STEPS.MEMBERSHIP}
        className={stepClassName}
      />
      <Step
        name={t('nav.steps.account')}
        stepId={STEPS.ACCOUNT}
        className={`mc-ml-2 ${stepClassName}`}
      />
      <Step
        name={t('nav.steps.payment')}
        stepId={STEPS.PAYMENT}
        className={`mc-ml-2 ${stepClassName}`}
      />
    </div>
  )
}
